<template>
  <footer class="footer">
    <!-- <div class="footer-tool">
      <div class="item">
        
      </div>
      <div class="item">
        <p>在线咨询</p>
        <div class="tips">
          <p>人工客服</p>
          <p>0755-33528888</p>
          <p>9:00-21:00</p>
        </div>
      </div>
      <div class="item">
        <p>公众号福利</p>
        <div class="tips">
          <div class="image"></div>
          <p>扫码关注公众号</p>
        </div>
      </div>
      <div class="gotop item"
           @click="goTop">
        <p>回到顶部</p>
      </div>
    </div> -->

    <div class="baiduline">
      <a href="javascript:;" class="baiduline-btn" title="在线客服">
        <div class="desc">
          <p>人工客服<br>9:00-21:00</p>
        </div>
      </a>
    </div>

    <div class="footer-top container">
      <ul>
        <li>
          <a href="javascript:void(0)">
            <i class="iconfont icon-kuaidi"></i>全国回收免邮费
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <i class="iconfont icon-shangmen"></i>66个上门回收地区
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <i class="iconfont icon-user"></i>数百万用户选择
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <i class="iconfont icon-anquan"></i>专业检测保护隐私
          </a>
        </li>
        <li>
          <a href="javascript:void(0)">
            <i class="iconfont icon-dakuan"></i>高价回收,闪电付款
          </a>
        </li>
      </ul>
    </div>
    <div class="footer-links container">
      <dl class="col-links">
        <dt>关于我们</dt>
        <dd>
          <a href="https://www.suhuishou.com/about/4.html">联系我们</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/5.html">了解速回收</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/4.html">商务合作</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/13.html">人才招聘</a>
        </dd>
      </dl>
      <dl class="col-links">
        <dt>交易方式</dt>
        <dd>
          <a href="https://www.suhuishou.com/about/7.html">上门交易</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/12.html">快递回收</a>
        </dd>
        <!-- <dd><a href="https://www.suhuishou.com/about/7.html">合作商家回收</a></dd> -->
      </dl>
      <dl class="col-links">
        <dt>帮助中心</dt>
        <dd>
          <a href="https://www.suhuishou.com/about/8.html">常见问题</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/14.html">邮寄地址</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/30.html">回收须知</a>
        </dd>
        <!-- <dd><a href="https://www.suhuishou.com/about/8.html">信用租机</a></dd> -->
      </dl>
      <dl class="col-links">
        <dt>服务中心</dt>
        <dd>
          <a href="https://www.suhuishou.com/about/10.html">质检说明</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/about/19.html">服条条款</a>
        </dd>
      </dl>
      <dl class="col-links">
        <dt>网站动态</dt>
        <dd>
          <a href="https://www.suhuishou.com/articles/10.html">常见问题</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/articles/12.html">回收咨询</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/articles/13.html">手机百科</a>
        </dd>
        <dd>
          <a href="https://www.suhuishou.com/articles/10.html">网站导航</a>
        </dd>
      </dl>
      <dl class="col-contact">
        <dt>
          <a href="javascript:;" class="baiduline-btn">在线客服</a>
          <p>
            周一至周日
            <br>早上9点 到 21点
          </p>
        </dt>
        <dd>寄件地址：深圳市南山区大冲国际中心18AD2</dd>
        <dd>0755-33528888</dd>
        <dd>收件人 : 张小勇(收)</dd>
      </dl>
    </div>
    <div class="copyright">
      <div class="container">
        <p>深圳市南山区大冲国际中心18AD2 <a href="https://beian.miit.gov.cn" rel="nofollow">粤ICP备16015090号</a><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004776" rel="nofollow">粤公网安备 44030502004776 号</a><a href="https://beian.miit.gov.cn/#/Integrated/index" rel="nofollow">增值电信业务经营许可证 粤B2-20211546</a></p>  
      </div>
      <div class="container"><p style="text-align: left;">© 2005-2021 深圳协腾网络电子科技有限公司 版权所有，并保留所有权利。 </p></div>
    </div>
  </footer>
</template>
<script>
export default {
  props: ["title"],
  methods: {
    goTop () {
      var gotoTop = function () {
        window.scrollTo(0, 0);
        clearInterval(timer);
        timer = null;
      };
      var timer = setInterval(gotoTop, 1);
    }
  }
};
</script>
<style scoped>
.baiduline a{
  display: block;
  color: #666;
  position: fixed;
  right: 20px;
  background: url(//image.suhuishou.com/uploads/file/20220917/2022091717150069566.png) no-repeat;
  background-size: 100px;
  width: 80px;
  height: 80px;
  top: 80%;
  background-size: 100%;
}
.baiduline .desc {display: block;width: 90px;height: 60px;position: absolute;left: -106px;top: 20px;border: 1px solid #e0e0e0;padding: 5px;background-color: #fff;display: none}
.baiduline .desc:after, .baiduline .desc:before {content: '';position: absolute;top: 20px;right: -19px;width: 0;height: 0;border-width: 10px;border-color: transparent;border-style: dashed dashed dashed solid;border-left-color: #fff}
.baiduline .desc:before {border-left-color: #e0e0e0;right: -20px}
.baiduline .desc p{font-size:12px;margin:5px 0 0 5px;}

.baiduline a:hover .desc{
  display: block;
}
/* .footer-tool {
  background: #fff;
  box-shadow: #aaa 0 0 1px;
  position: fixed;
  right: 0;
  bottom: 100px;
  width: 96px;
  height: 296px;
}
.footer-tool .item {
  position: relative;
}
.footer-tool .item .tips {
  position: absolute;
  top: 0px;
  left: -115px;
  background: #fff;
  padding: 10px;
  border: solid #e0e0e0 1px;
  display: none;
}
.footer-tool .item .tips:before,
.footer-tool .item .tips:after {
  content: "";
  position: absolute;
  top: 20px;
  right: -19px;
  width: 0;
  height: 0;
  border-width: 10px;
  border-color: transparent;
  border-style: dashed dashed dashed solid;
  border-left-color: #fff;
}
.footer-tool .item .tips:before {
  border-left-color: #e0e0e0;
  right: -20px;
}
.footer-tool .item:hover .tips {
  display: block;
}
.footer-tool .item::before {
  content: "";
  display: block;
  width: 40px;
  height: 40px;
  background: url(../../../assets/image/footer_tool.png) no-repeat;
  background-size: 100%;
  margin: 18px auto 0;
}
.footer-tool .item:nth-child(2):before {
  background-position: 0px -40px;
}
.footer-tool .item:nth-child(3):before {
  background-position: 0px -83px;
}
.footer-tool .item:nth-child(4):before {
  background-position: 0px -132px;
}
.footer-tool .item:nth-child(3) .tips {
  padding: 5px;
}
.footer-tool .item:nth-child(3) .tips .image {
  width: 80px;
  height: 80px;
  background: url(https://suhuishoutp.oss-cn-shenzhen.aliyuncs.com/assets/image/qrcode.jpg)
    no-repeat;
  background-size: 100%;
  margin: 0px auto 0px;
}
.footer-tool .item p {
  text-align: center;
  font-size: 12px;
} */
.gotop {
}
.gotop i {
  font-size: 20px;
}
</style>
